var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preference-switch" },
    [
      _c("a", {
        staticClass: "mask",
        on: {
          click: function($event) {
            return _vm.toggleSettings(_vm.id)
          }
        }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: _vm.id } }, [
        _vm.id === "showAcceptingChangesInfo"
          ? _c("span", [
              _vm._v(
                _vm._s(
                  _vm.brandTemplate !== "generic_2"
                    ? _vm.$t("BetSlip.placement." + _vm.id + ".label")
                    : _vm.$t("BetSlip.placement." + _vm.id + ".labelSwitch")
                )
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.id === "rememberSingleBetSlipStake"
          ? _c("span", [
              _vm._v(_vm._s(_vm.$t("BetSlip.placement." + _vm.id + ".label")))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.id === "rememberSingleBetSlipStake" ||
      _vm.brandTemplate !== "generic_2"
        ? _c("v-checkbox", {
            attrs: {
              "on-icon": "check_box",
              "off-icon": "check_box_outline_blank",
              id: _vm.id,
              disabled: _vm.currentBetSlipState >= 2
            },
            on: {
              click: function($event) {
                return _vm.toggleSettings(_vm.id)
              }
            },
            model: {
              value: _vm.combo,
              callback: function($$v) {
                _vm.combo = $$v
              },
              expression: "combo"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.brandTemplate === "generic_2" && _vm.id === "showAcceptingChangesInfo"
        ? [
            _c("v-switch", {
              attrs: { id: _vm.id, disabled: _vm.currentBetSlipState >= 2 },
              on: {
                click: function($event) {
                  return _vm.toggleSettings(_vm.id)
                }
              },
              model: {
                value: _vm.combo,
                callback: function($$v) {
                  _vm.combo = $$v
                },
                expression: "combo"
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f78ea63", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f78ea63","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/rootElements/preferenceSwitch.vue
// module id = null
// module chunks = 